import Axios from 'axios';
import { GenericReport } from "@/assets/types";
import { objectUtils } from "@/services/utils";
import moment from "moment";
import { financialCalculations } from "./financialCalculations";
let $success = null;
let $error = null;
const dates = {
    start: Date,
    end: Date
};
const compareDates = {
    start: Date,
    end: Date
};
const financialToolsConfig = {
    _defaultReport: new GenericReport("Financial"),
    loading: false,
    GetReport: async function (reportObj, reportOptions) {
        if (!reportObj) {
            reportObj = this._defaultReport;
        }
        dates.start = moment.utc(reportObj.filter?.date?.startDate) || moment.utc().toDate().setFullYear(moment.utc().toDate().getFullYear() - 1);
        dates.end = moment.utc(reportObj.filter?.date?.endDate) || moment.utc().toDate;
        try {
            const copy = {
                Id: reportObj.Id,
                type: reportObj.type,
                filter: JSON.parse(JSON.stringify(reportObj.filter))
            };
            delete reportObj.results;
            let uri = "/api/v2/financial/report";
            const qs = [];
            if (reportOptions?.saveReport === true) {
                qs.push({ k: "saveReport", v: true });
            }
            if (reportOptions?.refresh === true) {
                qs.push({ k: "refresh", v: true });
            }
            uri += qs.length > 0 ? "?" + qs.map(q => q.k + "=" + q.v).join('&') : "";
            const response = await Axios.post(uri, { report: copy }, { cancelToken: reportObj?.cancelToken?.token });
            //@ts-ignore
            if (response.message) {
                reportObj.results = [];
                return reportObj;
            } //Cancelled but not jumping to catch?
            reportObj.Id = response.data.Id;
            reportObj.lastCached = moment.utc(response.data.lastCached, "YYYY-MM-DDTHH:mm:ss");
            reportObj.results = response.data.results.map(result => {
                if (result["reportGroups"]) {
                    result["reportGroups"] = objectUtils.toCamelCase(JSON.parse(result["reportGroups"]));
                }
                else {
                    result["reportGroups"] = [];
                }
                return result;
            });
            return reportObj;
        }
        catch (err) {
            if (Axios.isCancel(err))
                return reportObj;
            $error("Report failed to run.");
            return reportObj;
        }
    },
    GetCompare: async function (reportObj, reportOptions) {
        if (!reportObj) {
            reportObj = this._defaultReport;
        }
        //const relativeDays = Math.abs(reportObj.filter.date.endDate - reportObj.filter.date.startDate) / (1000 * 60 * 60 * 24);
        try {
            const copy = {
                filter: JSON.parse(JSON.stringify(reportObj.filter)),
            };
            const startDate = moment.utc(copy.filter.date.startDate).add(-1, 'year').toDate();
            const endDate = moment.utc(copy.filter.date.endDate).add(-1, 'year').toDate();
            //startDate.setDate(startDate.getDate() - 365);
            //endDate.setDate(endDate.getDate() - 365);
            copy.filter.date.startDate = startDate;
            copy.filter.date.endDate = endDate;
            compareDates.start = startDate;
            compareDates.end = endDate;
            delete reportObj.compare;
            const qs = [{ k: "compare", v: true }];
            if (reportOptions?.refresh === true) {
                qs.push({ k: "refresh", v: true });
            }
            const uri = "/api/v2/financial/report" + "?" + qs.map(x => x.k + "=" + x.v).join("&");
            const response = await Axios.post(uri, { report: copy }, { cancelToken: reportObj?.cancelToken?.token });
            //@ts-ignore
            if (response.message) {
                reportObj.compare = [];
                return reportObj;
            } //Cancelled but not jumping to catch?
            reportObj.compare = response.data.results.map(result => {
                if (result["reportGroups"]) {
                    result["reportGroups"] = objectUtils.toCamelCase(JSON.parse(result["reportGroups"]));
                }
                else {
                    result["reportGroups"] = [];
                }
                return result;
            });
            return reportObj;
        }
        catch (err) {
            if (Axios.isCancel(err))
                return reportObj;
            console.log("ERROR (Compare)", err, reportObj.cancelToken);
            $error("Compare failed to run.");
            return reportObj;
        }
    },
    GetBoydenianDetails: async function (reportObj) {
        if (!reportObj) {
            reportObj = this._defaultReport;
        }
        try {
            const copy = {
                Id: reportObj.Id || 0,
                type: reportObj.type,
                filter: JSON.parse(JSON.stringify(reportObj.filter))
            };
            const response = await Axios.post("/api/v2/financial/report/boydenians", { report: copy }, { cancelToken: reportObj?.cancelToken?.token });
            return response.data || [];
        }
        catch (err) {
            $error("BoydenianDetails failed to run.");
            return [];
        }
    },
    ...financialCalculations
};
const financialTools = {
    install(app, options = {}) {
        $success = app.config.globalProperties.$success;
        $error = app.config.globalProperties.$error;
        app.provide("$financial", {
            getExportDateRange: () => ({ startDate: dates.start.valueOf(), endDate: dates.end.valueOf() }),
            getReport: financialToolsConfig.GetReport,
            getCompare: financialToolsConfig.GetCompare,
            getBoydenianDetails: financialToolsConfig.GetBoydenianDetails,
            getTotalBillings: (rows) => financialToolsConfig.GetTotalBillings(rows, dates),
            getTeamingValue: (rows) => financialToolsConfig.GetTeamingValue(rows, dates),
            getTeamingRevenue: (rows) => financialToolsConfig.GetTeamingRevenue(rows, dates),
            getTeamingTaken: (rows) => financialToolsConfig.GetTeamingTaken(rows, dates),
            getTeamingFilled: (rows) => financialToolsConfig.GetTeamingFilled(rows, dates),
            getAssignmentsTaken: (rows) => financialToolsConfig.GetAssignmentsTaken(rows, dates),
            getAssignmentsFilled: (rows) => financialToolsConfig.GetAssignmentsFilled(rows, dates),
            getTimeToFillSummary: (rows) => financialToolsConfig.GetTimeToFillSummary(rows, dates),
            getTimeToFill: (rows) => financialToolsConfig.GetTimeToFill(rows, dates),
            getExecutive: (rows) => financialToolsConfig.GetExecutive(rows, dates),
            getConsulting: (rows) => financialToolsConfig.GetConsulting(rows, dates),
            getIM: (rows) => financialToolsConfig.GetIM(rows, dates),
            getStrategyBillings: (rows) => financialToolsConfig.GetStrategyBillings(rows, dates),
            getStrategyTaken: (rows) => financialToolsConfig.GetStrategyTaken(rows, dates),
            getFilledJobValueSummary: (rows) => financialToolsConfig.GetFilledJobValueSummary(rows, dates),
            getFilledJobValue: (rows) => financialToolsConfig.GetFilledJobValue(rows, dates),
            getHeadcount: (rows) => financialToolsConfig.GetHeadcount(rows, dates),
            //getTaken: (rows) => financialToolsConfig.GetTaken(rows, dates),
            //getFilled: (rows) => financialToolsConfig.GetFilled(rows, dates),
            compare: {
                getTotalBillings: (rows) => financialToolsConfig.GetTotalBillings(rows, compareDates),
                getTeamingValue: (rows) => financialToolsConfig.GetTeamingValue(rows, compareDates),
                getTeamingRevenue: (rows) => financialToolsConfig.GetTeamingRevenue(rows, compareDates),
                getTeamingTaken: (rows) => financialToolsConfig.GetTeamingTaken(rows, compareDates),
                getTeamingFilled: (rows) => financialToolsConfig.GetTeamingFilled(rows, compareDates),
                getAssignmentsTaken: (rows) => financialToolsConfig.GetAssignmentsTaken(rows, compareDates),
                getAssignmentsFilled: (rows) => financialToolsConfig.GetAssignmentsFilled(rows, compareDates),
                getTimeToFillSummary: (rows) => financialToolsConfig.GetTimeToFillSummary(rows, compareDates),
                getTimeToFill: (rows) => financialToolsConfig.GetTimeToFill(rows, compareDates),
                getExecutive: (rows) => financialToolsConfig.GetExecutive(rows, compareDates),
                getConsulting: (rows) => financialToolsConfig.GetConsulting(rows, compareDates),
                getIM: (rows) => financialToolsConfig.GetIM(rows, compareDates),
                getStrategyBillings: (rows) => financialToolsConfig.GetStrategyBillings(rows, compareDates),
                getStrategyTaken: (rows) => financialToolsConfig.GetStrategyTaken(rows, compareDates),
                getFilledJobValueSummary: (rows) => financialToolsConfig.GetFilledJobValueSummary(rows, compareDates),
                getFilledJobValue: (rows) => financialToolsConfig.GetFilledJobValue(rows, compareDates),
                getHeadcount: (rows) => financialToolsConfig.GetHeadcount(rows, compareDates),
            }
        });
    }
};
export default financialTools;
